import { Avatar, Tooltip, Zoom } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import React from 'react'
import { colors } from '../../utils/constants'
import { numberFromText } from '../../utils/helpers'
import { useMediaQuery } from 'react-responsive'

const useStyles = makeStyles(theme => ({
  containerAvatarList: props => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    '& $avatarList:not(:first-child)': {
      marginLeft: -25
    },
    ...(props.length > 1 && {
      '&:hover $avatarList, &:hover $extraAvatar': {
        marginLeft: 0,
        transform: 'scale(1.06)'
      }
    })
  }),
  avatarList: props => ({
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    border: props.length === 1 ? 'none' : '2px solid white',
    borderRadius: '50%',
    transition: 'margin-left .25s ease, transform .25s ease',
    [theme.breakpoints.down(800)]: {
      display: props.length > 1 ? 'none' : 'flex'
    }
  }),
  extraAvatar: {
    marginLeft: -5,
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: '#ddd',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 'bold',
    transition: 'margin-left .25s ease, transform .25s ease'
  },
  toltipTitleOne: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  toltipTitleTwo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    maxHeight: 240,
    overflowY: 'auto',
    paddingRight: 4,
    '&::-webkit-scrollbar': {
      width: 6
    },
    '&::-webkit-scrollbar-track': {
      background: 'rgba(255,255,255,0.1)',
      borderRadius: 8
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(255,255,255,0.4)',
      borderRadius: 8
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'rgba(255,255,255,0.6)'
    },
    scrollbarWidth: 'thin',
    scrollbarColor: 'rgba(255,255,255,0.4) rgba(255,255,255,0.1)'
  },
  toltipTitleThree: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '4px 0'
  }
}))

const AvatarList = ({ data }) => {
  const maxToShow = 6
  const length = data.length
  const extraCount = Math.max(0, length - maxToShow)
  const classes = useStyles({ length })
  const extraContacts = data.slice(maxToShow)
  const isMobile = useMediaQuery({ query: '(max-width: 800px)' })
  return (
    <div className={classes.containerAvatarList}>
      {data.slice(0, maxToShow).map((item, index) => {
        const userColorName =
          numberFromText(item.name.slice(0, 2)) % colors.length
        return (
          <div
            key={index}
            className={classes.avatarList}
            style={{ zIndex: length - index }}
          >
            <Tooltip
              disableHoverListener={length <= 1 && !isMobile}
              arrow
              TransitionComponent={Zoom}
              placement='top'
              title={
                <div className={classes.toltipTitleOne}>
                  <Avatar
                    alt={item.name}
                    src={
                      item.avatar_url && item.avatar_url.trim() !== ''
                        ? item.avatar_url
                        : undefined
                    }
                    style={{
                      width: 32,
                      height: 32,
                      backgroundColor: colors[userColorName]
                    }}
                  >
                    {!item.avatar_url && item.name.charAt(0).toUpperCase()}
                  </Avatar>
                  <span>{item.name}</span>
                </div>
              }
            >
              <Avatar
                alt={item.name}
                src={
                  item.avatar_url && item.avatar_url.trim() !== ''
                    ? item.avatar_url
                    : undefined
                }
                style={{
                  width: 32,
                  height: 32,
                  backgroundColor: colors[userColorName]
                }}
              >
                {!item.avatar_url && item.name.charAt(0).toUpperCase()}
              </Avatar>
            </Tooltip>
            {length === 1 && !isMobile && <p>{item.name}</p>}
          </div>
        )
      })}

      {((extraCount > 0 && !isMobile) || (isMobile && length > 1)) && (
        <Tooltip
          TransitionComponent={Zoom}
          interactive
          arrow
          placement={isMobile ? 'top' : 'top-start'}
          disablePortal={false}
          PopperProps={{
            modifiers: {
              flip: { enabled: false },
              preventOverflow: { enabled: true, boundariesElement: 'window' }
            }
          }}
          title={
            <div className={classes.toltipTitleTwo}>
              {(isMobile ? data : extraContacts).map((item, index) => {
                const userColorName =
                  numberFromText(item.name.slice(0, 2)) % colors.length
                return (
                  <div key={index} className={classes.toltipTitleThree}>
                    <Avatar
                      src={
                        item.avatar_url && item.avatar_url.trim() !== ''
                          ? item.avatar_url
                          : undefined
                      }
                      style={{
                        width: 32,
                        height: 32,
                        backgroundColor: colors[userColorName]
                      }}
                    />
                    <span>{item.name}</span>
                  </div>
                )
              })}
            </div>
          }
        >
          <div className={classes.extraAvatar}>
            +{isMobile ? length : extraCount}
          </div>
        </Tooltip>
      )}
    </div>
  )
}

export default AvatarList
